import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant74() {
  const {
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const content = {
    ru: {
      cta: 'Получить макет'
    },
    ua: {
      cta: 'Отримати макет'
    },
    en: {
      cta: 'Get a mockup'
    }
  }[language] || content.ru;
  return <>
      <section className="relative min-h-screen w-full flex flex-col items-center justify-center px-4 pt-20 pb-12 bg-[#EAE8E3]" data-id="element-995">
        <div className="max-w-5xl mx-auto text-center flex flex-col items-center" data-id="element-996">
          {/* Using font-serif to match the elegant editorial vibe of the screenshot */}
          <h1 className="text-5xl md:text-6xl lg:text-[6rem] font-serif leading-[1.1] tracking-tight text-gray-900 uppercase" data-id="element-997">
            Создаем уникальные сайты
            <span className="inline-flex items-center justify-center mx-3 md:mx-5 align-middle w-16 h-16 md:w-24 md:h-24 bg-white rounded-full text-4xl md:text-5xl shadow-md" data-id="element-998">
              ✨
            </span>
            для клиентов,
            <br data-id="element-999" />
            нужно оплачивать
            <span className="inline-flex items-center justify-center mx-3 md:mx-5 align-middle w-16 h-16 md:w-24 md:h-24 bg-white rounded-full text-4xl md:text-5xl shadow-md" data-id="element-1000">
              🤝
            </span>
            только за обслуживание
            <br data-id="element-1001" />
            всего лишь
            <span className="inline-flex items-center justify-center mx-3 md:mx-5 align-middle px-8 py-2 bg-gray-900 text-[#EAE8E3] rounded-full text-4xl md:text-6xl font-serif shadow-xl" data-id="element-1002">
              {price}
            </span>
            в месяц
          </h1>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="mt-16" data-id="element-1003">
            <button onClick={() => setIsPopupOpen(true)} className="group flex items-center justify-center gap-2 rounded-full px-12 py-5 font-serif font-bold text-xl transition-all hover:scale-105 bg-gray-900 text-[#EAE8E3] shadow-xl" data-id="element-1004">
              {content.cta}
              <ArrowRightIcon className="w-6 h-6 transition-transform group-hover:translate-x-1" data-id="element-1005" />
            </button>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-1006" />
    </>;
}